module.exports = __webpack_public_path__ + "img/bg-profile-default.2a786ea1.jpg";